import { FC } from "react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";

export const Hero: FC = () => {
	return (
		<section className='relative bg-white'>
			<img
				className='absolute object-cover inset-0 w-full h-full opacity-25 sm:opacity-100'
				src='https://res.cloudinary.com/dp8g2jwak/image/upload/v1662126453/view-limited/hero/blue-forest_ijorty.jpg'
				alt='Couple on a bed with a dog'
			/>
			<div className='hidden sm:block sm:inset-0 sm:absolute sm:bg-gradient-to-r sm:from-black sm:to-transparent'></div>
			<div className='relative px-4 py-32 mx-auto max-w-screen-xl lg:h-screen lg:items-center lg:flex'>
				<div className='max-w-xl text-center sm:text-left'>
					<h1 className='text-4xl font-extrabold sm:text-7xl text-white font-display'>
						Business solutions you can trust
					</h1>

					<p className='max-w-lg mt-4 sm:leading-relaxed sm:text-xl text-white'>
						We are seasoned professionals specializing in forensic auditing, tax
						consulting and audit assurance.
					</p>

					<div className='flex justify-center md:justify-start mt-8 text-center gap-4'>
						<a href='mailto:project@viewlimited.com'>
							<button
								type='button'
								className='inline-flex items-center rounded-md border border-transparent bg-white hover:bg-gray-50 px-6 py-3 text-base font-medium text-blue shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
							>
								<EnvelopeIcon
									className='-ml-1 mr-3 h-5 w-5'
									aria-hidden='true'
								/>
								Email Us
							</button>
						</a>

						<a href='tel:+2347083999377'>
							<button
								type='button'
								className='inline-flex items-center rounded-md border border-transparent bg-white hover:bg-gray-50 px-6 py-3 text-base font-medium text-blue shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
							>
								<PhoneIcon className='-ml-1 mr-3 h-5 w-5' aria-hidden='true' />
								Call Us
							</button>
						</a>
					</div>
				</div>
			</div>
		</section>
	);
};
